import { _$post } from "./request/index";
import { encodePass } from "@/tools";
import { showSuccessToast, showFailToast } from "vant";
type paramsType = {
	userAccount: string;
	password: string;
	phoneCode: string;
	countryCode: string;
	lngType: string;
};
const singInApi = async (params: paramsType): Promise<objectType | null> => {
	params.password = encodePass(params.password);
	try {
		const result = _$post({
			url: "user/login",
			data: params
		});
		return result;
	} catch (e) {
		return null;
	}
};

export default singInApi;
